// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Xy-x7ydp0DMsMy4XSrhJag\\=\\={align-items:center;display:flex;gap:8px;justify-content:flex-end}._6lL0j0tU0z7yz4zb6dFscA\\=\\={background-color:#4c70ef}", "",{"version":3,"sources":["webpack://./resources/js/v2/pages/mcc/header/styles.module.scss"],"names":[],"mappings":"AAAA,4BAGE,kBAAA,CAFA,YAAA,CAGA,OAAA,CAFA,wBAGF,CAEA,6BACE,wBACF","sourcesContent":[".right_side {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n}\n\n.blue_button {\n  background-color: #4c70ef;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"right_side": "Xy-x7ydp0DMsMy4XSrhJag==",
	"blue_button": "_6lL0j0tU0z7yz4zb6dFscA=="
};
export default ___CSS_LOADER_EXPORT___;
